import script from "./SubMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./SubMenuItem.vue?vue&type=style&index=0&id=48f00940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f00940"]])

export default __exports__